import React from 'react';
import { Immutable } from 'nuclear-js';
import { Dropdown, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';

import Reactor from 'data/reactor';
import RuntimeGetters from 'data/app-runtime/getters';
import { findShowMethodForModal } from 'utils/runtime';
import { sharedModalReferences } from 'resources/common-values';
import Actions from 'data/actions';

export default CreateReactClass({
    displayName: 'ApplicationMenu',

    propTypes: {
        menuItems: PropTypes.instanceOf(Immutable.List).isRequired,
    },

    dropdownToggle(isOpen) {
        if (isOpen) {
            Analytics.recordButtonClick(CommonValues.SectionIDs.header, 'open-leftnav');
            //Show the save changes prompt if there is unsaved data
            if (Reactor.evaluate(RuntimeGetters.unsavedData)) {
                const showSaveDataPrompt = findShowMethodForModal(
                    Reactor.evaluate(RuntimeGetters.modalReferences),
                    sharedModalReferences.saveDataPrompt
                );
                showSaveDataPrompt()
                    .then(() => {
                        Actions.runtime.setUnsavedData(false);
                    })
                    .catch(() => {
                        /* do nothing */
                    });
            }
        } else {
            Analytics.recordButtonClick(CommonValues.SectionIDs.header, 'close-leftnav');
        }
    },

    

    render() {
        let menuItems = [];
        let eventKey = 0;
        this.props.menuItems.forEach((link) => {
            if (link.has('subMenu') && link.get('subMenu')) {
                menuItems.push(<MenuItem divider={true} key={`sub-${eventKey}`} />);

                link.get('subMenu').forEach((subLink) => {
                    eventKey++;
                    menuItems.push(
                        <MenuItem eventKey={eventKey} href={subLink.get('link')} key={eventKey}>
                            {subLink.get('displayText')}
                        </MenuItem>
                    );
                });
            } else {
                eventKey++;
                menuItems.push(
                    <MenuItem eventKey={eventKey} href={link.get('link')} key={eventKey}>
                        {link.get('displayText')}
                    </MenuItem>
                );
            }
        });

        return (
            <Dropdown id="links-dropdown" key="links-dropddown" onToggle={this.dropdownToggle}>
                <Dropdown.Toggle
                    className="hamburger-wrapper"
                    bsRole="toggle"
                    title="Open/Close Menu"
                    key="hamburger-wrapper"
                    noCaret={true}
                >
                    <div
                        id="left-nav-button"
                        className="hamburger-menu"
                        onClick={(e) => {
                            e.preventDefault();
                        }}
                        key="the-burger"
                    >
                        <span key="bun-top"></span>
                        <span key="meat"></span>
                        <span key="bun-bottom"></span>
                    </div>
                </Dropdown.Toggle>
                <Dropdown.Menu key="dropdown-menu">{menuItems}</Dropdown.Menu>
            </Dropdown>
        );
    },
});
